import { useEffect, useRef } from "react"

const initMapWhenScriptIsReady = (dom) => {
  const it = setInterval(() => {
    if (typeof google === "undefined") {
      initMapWhenScriptIsReady(dom);
      return;
    }
    clearInterval(it);
    initMap(dom);
  }, 1000);
}

function initMap(dom) {
  if (typeof google === "undefined") {
    return;
  }

  var styledMapType = new google.maps.StyledMapType(
    [
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#ffffff"
          }
        ]
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#000000"
          },
          {
            lightness: 13
          }
        ]
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000"
          }
        ]
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#144b53"
          },
          {
            lightness: 14
          },
          {
            weight: 1.4
          }
        ]
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#08304b"
          }
        ]
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#0c4152"
          },
          {
            lightness: 5
          }
        ]
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000"
          }
        ]
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#0b434f"
          },
          {
            lightness: 25
          }
        ]
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000"
          }
        ]
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#0b3d51"
          },
          {
            lightness: 16
          }
        ]
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000"
          }
        ]
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            color: "#146474"
          }
        ]
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#021019"
          }
        ]
      }
    ],
    { name: "Styled Map" }
  );

  var map = new google.maps.Map(dom, {
    zoom: 2,
    center: new google.maps.LatLng(2.8, -187.3),
    mapTypeId: "terrain",
    mapTypeControl: false,
    streetViewControl: false
  });

  map.mapTypes.set("styled_map", styledMapType);
  map.setMapTypeId("styled_map");
}

export default ({ data }) => {
  const {
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;

  const ref = useRef();

  useEffect(() => {
    if (!document.querySelector("#google-map-script")) {
      const script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBUBJ4sWdpQeHn6dnGCfZDs3j0egYxFdNI";
      script.async = true;
      script.id = "google-map-script";
      document.body.appendChild(script);
    }
    initMapWhenScriptIsReady(ref.current);
  }, []);

  return (
    <div style={{
      position: "relative", paddingTop,
      paddingBottom,
      paddingRight,
      paddingLeft,
    }}>
      <div ref={ref} style={{ minHeight: 400 }} />
      <div style={{ position: "absolute", top: 0, bottom: 0, right: 0, left: 0 }} />
    </div>
  );
}